import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useNavigationStore } from '../state/navigationStore'
import { I_SystemPost, useWpDataStore } from '../state/wpDataStore'
import { Accordion } from './Accordion'
import { Modal } from './Modal'
import { SystemTabIcon } from './Svg'
import { SystemAttributes } from './SystemAttributes'

const SystemModal = () => {
  const { systemModalOpen, setSystemModalOpen, selectedSystemPostId } =
    useNavigationStore(
      useShallow((state) => ({
        systemModalOpen: state.systemModalOpen,
        setSystemModalOpen: state.setSystemModalOpen,
        selectedSystemPostId: state.selectedSystemPostId,
      }))
    )

  const selectedSystemPost = useWpDataStore((s) =>
    s.getSystemById(selectedSystemPostId)
  )

  return systemModalOpen ? (
    <Modal
      // svgIcon={<SystemTabIcon />}
      title='System details'
      onClose={() => {
        setSystemModalOpen(false)
      }}
    >
      {selectedSystemPost && (
        <SystemModalContent systemPost={selectedSystemPost} />
      )}
    </Modal>
  ) : null
}

const SystemModalContent = ({ systemPost }: { systemPost: I_SystemPost }) => {
  const { id, title, acf } = systemPost
  const { introduction, accordion } = acf || {}
  const iconImage = acf?.icon

  return (
    <div className='system-modal'>
      <div className='system-modal__intro'>
        <div>
          <h3 className='system-modal__title'>{title?.rendered || `#${id}`}</h3>

          {/* Attributes */}
          <SystemAttributes systemPost={systemPost} />
        </div>

        {iconImage?.url && (
          <div className='system-modal__icon-wrapper'>
            <img src={iconImage.url} alt={iconImage.alt || ''} />
          </div>
        )}
      </div>

      {introduction && (
        <div
          className='system-modal__introduction'
          dangerouslySetInnerHTML={{ __html: introduction }}
        />
      )}

      {accordion && accordion.length > 0 && <Accordion sections={accordion} />}
    </div>
  )
}

export { SystemModal }
